import {
	Button,
	DrawerRight,
	Loading,
	TextField,
	Trackers,
} from 'src/components';
import { Grid } from '@material-ui/core';
import { useEffect } from 'react';
import { useFormik } from 'formik';

import { type IInstitution } from 'src/models';
import { type RootState } from 'src/store';
import { useDispatch, useSelector } from 'react-redux';
import institutionActions from 'src/store/Institutions/actions';

interface Props {
	open: boolean;
	onClose: () => void;
	institutionId?: number;
}

function DrawerForm({ institutionId, onClose, open }: Props) {
	// NOTE: Ver todas las notas de ./src/modules/private/Admin.tsx
	const dispatch = useDispatch();
	const { institution, isLoadingOne } = useSelector(
		(state: RootState) => state.institutions,
	);
	const create = (institution: IInstitution) =>
		dispatch(institutionActions.create(institution));
	const update = (institution: IInstitution) =>
		dispatch(institutionActions.update(institution));
	const getOne = (id: number) => dispatch(institutionActions.getOne(id));
	const clearInstitution = () => dispatch(institutionActions.setOne({}));

	const { handleChange, handleReset, handleSubmit, values } = useFormik({
		enableReinitialize: true,
		initialValues: institutionId ? institution : { name: '' },
		onSubmit: (values) => {
			if (institutionId) update(values);
			else create(values);
			onClose();
		},
	});

	useEffect(() => {
		if (open) {
			if (institutionId) getOne(institutionId);
		} else {
			handleReset({});
			clearInstitution();
		}
	}, [open, institutionId]);

	return (
		<DrawerRight
			onClose={onClose}
			open={open}
			title={`${institutionId ? 'Editar' : 'Agregar'} Institución`}
		>
			<Loading isLoading={isLoadingOne}>
				<Grid container spacing={2}>
					<Grid item xs={12}>
						<TextField
							label={'Nombre'}
							name={'name'}
							onChange={handleChange}
							value={values.name}
						/>
					</Grid>

					{Boolean(institutionId) && <Trackers model={institution} />}

					<Grid item xs={12}>
						<Button
							actionType={'save'}
							fullWidth
							onClick={() => {
								handleSubmit();
							}}
						>
							{institutionId ? 'Guardar Cambios' : 'Crear'}
						</Button>
					</Grid>
				</Grid>
			</Loading>
		</DrawerRight>
	);
}

export default DrawerForm;
